import cardImg from "../agroImg/mechI.png";
import cardImg2 from "../agroImg/manUi.png";
import cardImg3 from "../agroImg/shipI.png";

export const CardData = [
  {
    img: cardImg,
    title: "Machinery Provider",
    details:
      "We provide a platform where you can hire various machines and equipments for both long and short term",
  },
  {
    img: cardImg2,
    title: "Reliable Manufacturers",
    details:
      "We are able to supply a wide range of machinery from reputable manufactures such as, New Holland, John Deere, JCB, Case and Massey Ferguson, to name a few.",
  },
  {
    img: cardImg3,
    title: "Export Services",
    details:
      "We offer export services on our machinery to our international customers. We can take care of the paperwork",
  },
];
